<template>
  <Solutions :listTitle="listTitle" :content="content"/>
</template>

<script>
export default {
  data () {
    return {
      listTitle: '多物理耦合计算解决方案',
      content: '<div style="font-size:16px;text-indent:2em;">采用C/C++语言、面向对象技术开发，用于处理任意多物理场的耦合计算，实现通用耦合计算的所有必要功能，提供各物理场间强、弱耦合的混合支持。</div><br /><br /><div style="font-size:16px;text-indent:2em;padding-top:30px;">支持各物理场的线性及非线性计算、各物理场独立时间步控制、异类拓扑网格映射、耦合物理量同步操作、接触探测及各种接触处理、网格组合计算、边界条件及初值条件统一处理、单点约束及多点约束处理、集中荷载分布荷载及多点荷载处理等通用计算功能。</div><img src="../solution/1.png" style="width:500px;height:300px;margin:10px 100px;">'
    }
  }
}
</script>
